import React from 'react';
import TableRow from '../../../components/common/table-row';
import SimpleDate from '../../../components/common/date';
import { DOC_UPLOAD } from '../../../../src/constants';


const UploadHistoryListItemHeader = ({ data, statuses }) => {

    let status = '';
    let className = '';

    if (statuses) {
        statuses.map((item, i) => {
            if (item.id === data.status) {
                status = item.text;
            }
        })
    }
    className = DOC_UPLOAD.STATUS_META_DATA[status];

    return (
        <div className="data-container-wrapper">
            <TableRow>
                {/* <TableRow.Column align="center" /> */}
                <TableRow.Column align="left" >
                    <TableRow>
                        <TableRow.Column align="left">
                            <span className="headers-font">{data.bpId}</span>
                        </TableRow.Column>

                        <TableRow.Column align="left">
                            <span className="headers-font">{data.contract} </span>
                        </TableRow.Column>

                        <TableRow.Column align="left">
                            <span className="headers-font">{data.userName} </span>
                        </TableRow.Column>

                        <TableRow.Column  align="left">
                            <span className="headers-font">{data.dwoDocName}</span>
                        </TableRow.Column>

                        <TableRow.Column align="left">
                            <span className="headers-font">
                                {data.uploadDate}</span>
                        </TableRow.Column>

                        <TableRow.Column width={0.5} align="left">
                            <span className={`headers-font ${className} `}>{status}</span>
                        </TableRow.Column>
                    </TableRow>
                </TableRow.Column>
            </TableRow>
        </div>
    );
}

export default UploadHistoryListItemHeader;




